var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1663 37.3333L48.1663 29.3333H29.4997C28.7924 29.3333 28.1142 29.0524 27.6141 28.5523C27.114 28.0522 26.833 27.3739 26.833 26.6667V10.6667C26.833 9.95942 27.114 9.28115 27.6141 8.78105C28.1142 8.28095 28.7924 8 29.4997 8H53.4997C54.2069 8 54.8852 8.28095 55.3853 8.78105C55.8854 9.28115 56.1663 9.95942 56.1663 10.6667V37.3333Z",
    stroke: "#DD4242",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4998 39.9998V45.3332C37.4998 46.0404 37.2189 46.7187 36.7188 47.2188C36.2187 47.7189 35.5404 47.9998 34.8332 47.9998H16.1665L8.1665 55.9998V29.3332C8.1665 28.6259 8.44746 27.9477 8.94755 27.4476C9.44765 26.9475 10.1259 26.6665 10.8332 26.6665H16.1665",
    stroke: "#DD4242",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.48f3508f.svg";
export { ForwardRef as ReactComponent };